<template>
  <div class="app-user-agreement_aua">

    <input-title
      v-if="options.title"
      :required="options.required"
      :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group"
        @click="removeError(i)">

        <el-checkbox v-model="isChecked[i]" disabled></el-checkbox>

        <button class="aua_btn" @click="showDialog(i)">
          Согласие на обработку персональных данных *
        </button>

        <div v-if="error[i]" class="ait_message ait_message--error">{{ error[i] }}</div>

      </div>

      <el-dialog
        title="Согласие на обработку персональных данных"
        :visible.sync="dialogVisible">
        <div style="text-align: left;">
          <div class="rw_text" v-html="userAgreement.text" ></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="dialog-primary-btn" @click="userAnswer(true)">
            Согласиться</el-button>
          <el-button class="dialog-empty-btn" @click="userAnswer(false)">
            Отказаться</el-button>
        </span>
      </el-dialog>

    </div>

    <input-example :example="options.example"/>

    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import userAgreement from '@/data/user-agreement';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
      userAgreement,
      isChecked: [],
      dialogVisible: false,
      curIndex: 0,
      validateMessages: {
        required: 'Необходимо Ваше согласие!',
      },
    };
  },

  watch: {

    valueLocal() {
      this.isChecked = [];
      this.valueLocal.forEach((el, i) => {
        this.isChecked[i] = !!el;
      });
    },

  },

  methods: {

    userAnswer(answer) {
      this.valueLocal[this.curIndex] = answer ? this.userAgreement : '';
      this.updateValue();
      this.dialogVisible = false;
    },

    showDialog(i) {
      this.curIndex = i;
      this.dialogVisible = true;
    },

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          const result = approve.value(value, { required: true });
          this.error[i] = result.approved ? '' : this.validateMessages.required;
        });
      }
      this.updateValue();
      return this.error;
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-user-agreement_aua {
  text-align: center;
  .el-dialog {
    max-width: 900px;
    .dialog-footer {
      .el-button {
        font-size: 15px;
        padding: 8px 20px;
      }
    }
    @media (max-width: 600px) {
      .el-dialog__header {
        text-align: left;
        .el-dialog__title {
          padding: 0 30px 0 0;
          display: block;
        }
      }
    }
  }
  .el-checkbox {
    margin: 15px 15px 0 0;
    vertical-align: top;
    display: inline-block;
    @media (max-width: 550px) {
      margin-top: 22px;
    }
  }
  .el-checkbox__input.is-disabled .el-checkbox__inner {
    cursor: default;
    &::after {
      cursor: default;
      border-color: #fff;
    }
  }
  .aua_btn {
    text-align: center;
    color: #fff;
    @include border-radius;
    border: 1px solid #d85486;
    cursor: pointer;
    font-size: 15px;
    line-height: 20px;
    padding: 10px 15px;
    font-weight: 300;
    display: inline-block;
    vertical-align: middle;
    margin: 0 5px;
    @include transition;
    white-space: normal;
    &:hover {
      border-color: transparent;
      background: #d85486;
    }
    @media (max-width: 550px) {
      width: 190px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppUserAgreement.vue